import React from 'react';
import { SC_SlideButton, SC_SlideButtonLine } from './SlideButton.styled';
import { UHC_SliderProps } from '../Slider';
import { calcSlideButtonLeft } from './SlideButton.service';
import { SliderColorsOptions, getSliderColor } from '../sliderColors';
export interface SlideButtonProps{
    pipes: UHC_SliderProps['pipes'],
    pipeSelected: UHC_SliderProps['pipeState']['pipeSelected'],
    sizes:{
        button:number,
        pipe:number
    }
    color: SliderColorsOptions
}

const UHC_SlideButton: React.FC<SlideButtonProps> = (props: SlideButtonProps) => {
    const pointLeft = calcSlideButtonLeft(props.color, props.pipeSelected, props.pipes.length, props.sizes.button, props.sizes.pipe);

    return (
        <SC_SlideButton color={getSliderColor(props.color)} point={{...pointLeft.point}}>
            <div style={{ display: 'flex' }}>
                <SC_SlideButtonLine color='white' />
                <SC_SlideButtonLine color='gray' />
            </div>

            <div style={{ display: 'flex' }}>
                <SC_SlideButtonLine color='white' />
                <SC_SlideButtonLine color='gray' />
            </div>

            <div style={{ display: 'flex' }}>
                <SC_SlideButtonLine color='white' />
                <SC_SlideButtonLine color='gray' />
            </div>

        </SC_SlideButton>
    );
}

export default UHC_SlideButton;